/**
 * SFrame210 — Evaluate Federal Estate Tax (checklist-only).
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-210';

const ITEMS = [
  {
    id: 'i10-1',
    title: 'Calculate Gross Estate Value',
    description:
      'Add all assets including real property, accounts, investments, life insurance, and business interests.',
  },
  {
    id: 'i10-2',
    title: 'Check Federal Filing Threshold',
    description:
      'Determine if the gross estate exceeds the current federal estate tax exemption (Form 706 may be required).',
  },
  {
    id: 'i10-3',
    title: 'Assess Portability (Form 706)',
    description:
      "Even if no estate tax is owed, consider filing Form 706 to preserve the deceased spouse's unused exemption.",
  },
];

export default function SFrame210() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId)
    return <div className="max-w-2xl mx-auto py-12 px-4 text-sm text-stone-600">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="Evaluate Federal Estate Tax"
      backTo={`/sframe-207/${estateId}`}
      backLabel="← Tax Filings"
      items={ITEMS}
      syncTaxDt4Guided
    />
  );
}
